// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"804dbfe3","213":"b3c76730","239":"ecd41f8c","455":"bddaf311"}[chunkId] + ".chunk.js";
};